import { Grid } from "@material-ui/core";
import React from "react";
import { CustomOptions } from "./models/TrendingModels";
import { useTrendingStyles } from "./styles/TrendingStyles";

interface CustomOptionsComponentProps {
	customOptions: CustomOptions;
	setCustomOptions: React.Dispatch<React.SetStateAction<CustomOptions>>;
}

const CustomOptionsComponent: React.FC<CustomOptionsComponentProps> = ({
	customOptions,
	setCustomOptions,
}) => {
	const classes = useTrendingStyles();

	const handleGridChange = (value: boolean) => {
		setCustomOptions((prevOptions) => ({
			...prevOptions,
			showGrid: value,
		}));
	};

	const handleSteppedChange = (value: boolean) => {
		setCustomOptions((prevOptions) => ({
			...prevOptions,
			stepped: value,
		}));
	};

	return (
		<>
			<Grid item className={classes.labelOptions}>
				<label>
					<input
						type="checkbox"
						checked={customOptions.showGrid}
						onChange={(e) => handleGridChange(e.target.checked)}
					/>
					Show Grid
				</label>
			</Grid>
			<Grid item className={classes.labelOptions}>
				<label>
					<input
						type="checkbox"
						checked={customOptions.stepped}
						onChange={(e) => handleSteppedChange(e.target.checked)}
					/>
					Stepped
				</label>
			</Grid>
		</>
	);
};

export default CustomOptionsComponent;
